import {Modal} from "@material-ui/core";
import AuthSection from "./AuthSection";
import React from "react";
import Box from "@material-ui/core/Box";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modalRoot: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(2),
    },
    modalFrame: {
        width: "100%",
        maxWidth: 920,
        maxHeight: "calc(100vh - 48px)",
        borderRadius: theme.spacing(3),
        boxShadow: theme.shadows[10],
        outline: "none",
        overflow: "hidden",
        display: "flex",
    },
    modalContent: {
        width: "100%",
        overflowY: "auto",
    },
}));

interface SignupPopupProps {
    signupModal: any
    setSignupModal: any
}

export function SignupPopup({signupModal, setSignupModal}: SignupPopupProps) {
    const classes = useStyles();
    return <Modal
        open={signupModal}
        onClose={() => setSignupModal(false)}
        className={classes.modalRoot}
    >
        <Box className={classes.modalFrame}>
            <Box className={classes.modalContent}>
                <AuthSection
                    bgColor="default"
                    size="medium"
                    bgImage=""
                    bgImageOpacity={1}
                    type={'signup_required'}
                    providers={["google"]}
                    afterAuthPath={() => {
                        setSignupModal(false)
                    }}
                />
            </Box>
        </Box>
    </Modal>;
}
